import styled from 'styled-components';
import { Scroll } from '../../util/shared';
import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import UserContext from '../../context/UserContext';
import Moment from 'react-moment'
const Recent = () => {

      const [searchQuery, setSearchQuery] = useState('');
  const path = window.location.pathname;
  const nav = useNavigate();
  const [recents, setRecents] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
const {apiURL} = useContext(UserContext)
  useEffect(() => {
    const getUsers = async () => {
      try {
        const res = await axios.get(`${apiURL}/files/getrecent`);
     
        if(Array.isArray(res.data.message)){setRecents(res.data.message)}
      } catch (error) {
        console.error('Error fetching users:', error);
      }
    };

    getUsers();
  }, []);

const sortTable = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }

    const sortedCustomers = [...recents].sort((a, b) => {
      if (a[key] < b[key]) return direction === 'asc' ? -1 : 1;
      if (a[key] > b[key]) return direction === 'asc' ? 1 : -1;
      return 0;
    });

    setRecents(sortedCustomers);
    setSortConfig({ key, direction });
  };

  const getSortIndicator = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === 'asc' ? ' ↑' : ' ↓';
    }
    return '';
  };
 
  return (
<>
          <div className="flex w-full h-[10vh] mt-[60px] px-[10vw] justify-between items-center">
        <div className="flex-1 max-w-md text-left">
          <label className="block text-sm font-medium text-gray-700">Search</label>
              <input
            className="w-full bg-transparent placeholder:text-slate-400 text-slate-700 text-sm border border-slate-200 rounded-md px-3 py-2 transition duration-300 ease focus:outline-none focus:border-slate-400 hover:border-slate-300 shadow-sm focus:shadow"
            placeholder="Type here..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>
        <div className="flex-1 text-right">
          <button
            type="button"
             className="text-white bg-gradient-to-r from-green-400 via-green-500 to-green-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-green-300 dark:focus:ring-green-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2"
           onClick={e => window.location.reload()}
          >
            Reload List
          </button>
        </div>
      </div>
     <div className="p-4">
      
          <table className="w-full bg-white border border-gray-200">
            <thead className="bg-gray-100 sticky top-0">
              <tr className="flex w-full">
                  <th
                  className="  flex-1 px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer"
                  onClick={() => sortTable('company')}
                >
                  Company{getSortIndicator('company')}
                </th>
                <th
                  className="  flex-1 px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer"
                  onClick={() => sortTable('uploadName')}
                >
                  User{getSortIndicator('uploadName')}
                </th>
                <th
                  className="  flex-1 px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer"
                  onClick={() => sortTable('originalFilename')}
                >
                  File{getSortIndicator('originalFilename')}
                </th>
                <th
                  className="  flex-1 px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer"
                  onClick={() => sortTable('sisizeze')}
                >
                  Size{getSortIndicator('size')}
                </th>
                <th
                  className=" flex-1 px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer"
                  onClick={() => sortTable('type')}
                >
                  Type{getSortIndicator('type')}
                </th>
                 <th
                  className=" flex-1 px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer"
                  onClick={() => sortTable('createdAt')}
                >
                  Uploaded{getSortIndicator('createdAt')}
                </th>
              </tr>
            </thead>
           
              <tbody className="min-w-full ">
                 <Scroll height="400px" width="100vw">
                {recents?.filter((recent) =>
                    recent.uploadName?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                    recent.originalFilename?.toLowerCase().includes(searchQuery.toLowerCase())||
                    recent.company?.toLowerCase().includes(searchQuery.toLowerCase())
                  )
                  ?.map((recent) => (
                    <tr key={recent._id} className="flex w-full hover:bg-gray-50">
                         <td className=" flex-1 px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider cursor-pointer">{recent.company}</td>
                      <td className=" flex-1 px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider cursor-pointer ">{recent.uploadName}</td>
                      <td className="  flex-1 px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider cursor-pointer break-all">{recent.originalFilename}</td>
                      <td className=" flex-1 px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider cursor-pointer">{recent.size}kb</td>
                      <td className="  flex-1 px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider cursor-pointer">
                        {recent.type}
                      </td>
                      <td className="  flex-1 px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider cursor-pointer">
<Moment format="MM/DD/YY hh:mm:ss">{recent.createdAt}</Moment>
                       
                     </td> 
                    </tr>
                  ))}
                    </Scroll>
              </tbody>
          
          </table>
        
      </div>
      </>
  )
}

export default Recent